import { render, staticRenderFns } from "./UpgradeAccountModal.vue?vue&type=template&id=5e858d3a"
import script from "./UpgradeAccountModal.vue?vue&type=script&lang=js"
export * from "./UpgradeAccountModal.vue?vue&type=script&lang=js"
import style0 from "./UpgradeAccountModal.vue?vue&type=style&index=0&id=5e858d3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports